import React from 'react'
import "./AboutUs.css";
import { Link } from "react-router-dom";

import abtsBnr from "../../assets/imgs/abtsBnr.jpg";
import abtBuild from "../../assets/imgs/abtBuild.jpg";
import missImg from "../../assets/imgs/icons/mission-icon.svg";
import teleImg from "../../assets/imgs/icons/telescope-icon.svg";
import ReadyToBusiness from '../ReadyToBusiness/ReadyToBusiness';
import { Button } from "@mui/material";
import { Helmet } from "@dr.pogodin/react-helmet";

function AboutUs() {
  return (
    <div className='abtMn'>
      <Helmet>
                    <title>About Us |  PAYTECH ADVISOR</title>
                  </Helmet>
      <div className="maxW">
        <div className="abtTp">
          <h2>
            Advisory You Can Trust. <br></br>
            Solutions That Deliver.
          </h2>
          <p>At Paytech Advisors, we are more than a consultancy<br></br>
            — we are your strategic partner in growth.</p>
         <Button
                       variant="contained"
                       component={Link}
                       to="/contact-us"
                       className="wbtnLink"
                     >
                       Contact Us
                     </Button>
        </div>
        <div className='abimgWrp'>
          <img src={abtsBnr} alt="abtsBnr" />
        </div>
        <div className='abpWrp'>
          <p>Specializing in payment solutions, business strategy, marketing, and technology, we help businesses
            navigate challenges and seize opportunities with clarity, confidence, and measurable results.</p>
          <p>Our philosophy is simple: <strong>we don’t sell, we solve</strong>. Every recommendation we make is grounded in
            deep market insight, operational expertise, and a commitment to your long-term success. Whether
            you need a seamless payment ecosystem, a winning market entry strategy, or cuting-edge tech
            solutions, we deliver with precision and purpose.</p>
        </div>
        <div className='mvWRap'>
          <div className='mvCrd'>
            <div className='mvisWrap'>
              <img src={missImg} alt="missImg" />
            </div>
            <h3>Mission</h3>
            <p>Redefining business advisory by delivering smart, secure, and scalable solutions in payments,
              technology, marketing, and growth strategy.</p>
          </div>
          <div className='mvCrd'>
            <div className='mvisWrap'>
              <img src={teleImg} alt="teleImg" />
            </div>
            <h3>Vision</h3>
            <p>To be the most trusted partner for businesses, driving innovation, efficiency, and sustainable growth
              through holistic, future-ready advisory services.</p>
          </div>
        </div>
        <div className='abBuild'>
          <div className='abBLft'>
            <h2>“Solutions Simplified. Growth Amplified”</h2>
            <p>With Paytech Advisors, you gain more than advice — you gain a trusted ally dedicated to
              transforming challenges into opportunities and ideas into profitable realities</p>
          </div>
          <div className='abBRyt'>
            <img src={abtBuild} alt="abtBuild" />
          </div>
        </div>
      </div>
      <ReadyToBusiness />
    </div>
  )
}

export default AboutUs